import IssueTable from "../tabs/IssueTable";
import { formatDDMMYYYY } from "../../../utils/dateUtils";

export default function OtherEditions({ superseded = [], replaced = [] }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      {replaced.length > 0 && (
        <IssueTable
          title="This Issue is replaced by the following issue"
          data={replaced.map((item) => ({
            ref: item.referenceNumber,
            title: item.title,
            standardId: item.standardId,
            issue: item.issue,
            publicationDate: formatDDMMYYYY(
              item.issueDate ?? item.publicationDate,
            ),
            endDate: formatDDMMYYYY(item.withdrawnDate),
          }))}
          emptyMessage="No replaced documents"
        />
      )}
      {superseded.length > 0 && (
        <IssueTable
          title="This issue has superseded the following historical issues."
          data={superseded.map((item) => ({
            ref: item.referenceNumber,
            title: item.title,
            standardId: item.standardId,
            issue: item.issue,
            publicationDate: formatDDMMYYYY(
              item.issueDate ?? item.publicationDate,
            ),
            endDate: formatDDMMYYYY(item.withdrawnDate),
          }))}
          emptyMessage="No superseded issues"
        />
      )}
    </div>
  );
}
